import React, { useEffect, useState } from "react";
import axios from "axios";

import Combobox from "react-widgets/Combobox";
import "react-widgets/styles.css";
import plusIcon from "../../assets/icons/plus-icon.png";

import ServiceGroupModal from "./service-group/ServiceGroup-modal";
import ServiceForm from "./service-modal";
import useService from "../../hooks/services/useService";
import AlertMessage from "../../components/AlertMessage";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal";
import Breadcrumb from "../../components/Breadcrumb";
import Table from "../../components/Table/Table.jsx";

const Services = () => {
  const {
    newService,
    services,
    displayServices,
    selectedServiceGroup,
    showModal,
    serviceGroupName,
    handleChange,
    onSave,
    onCloseModalClick,
    setSelectedServiceGroup,
    setServiceGroupName,
    serviceGroupOrder,
    setServiceGroupOrder,
    onFormClick,
    showNewModal,
    setShowNewRow,
    editService,
    showEditModal,
    setShowEditModal,
    onEditClick,
    onAddClick,
    onEditSave,
    showMessage,
    message,
    setShowMessage,
    setDeleteItem,
    showDeleteModal,
    onCloseDeleteModal,
    handleDeleteClick,
    handleConfirmDelete,
    errors,
    columns,
  } = useService();

  return (
    <div className="content">
      <div className="content-block">
        <Breadcrumb parent="Services" child="All Services" />
        {showMessage && (
          <AlertMessage
            key={message.text}
            setVisible={setShowMessage}
            message={message.text}
            type={message.type}
            duration={4000}
          />
        )}
        <ServiceGroupModal
          handleChangeOrder={(e) => setServiceGroupOrder(e.target.value)}
          orderNumber={serviceGroupOrder}
          onCloseModalClick={onCloseModalClick}
          showModal={showModal}
          serviceGroupName={serviceGroupName}
          handleChangeName={(e) => setServiceGroupName(e.target.value)}
          onFormClick={onFormClick}
          maxRow={services.length + 1}
          title={"New Service Group"}
        />
        {showNewModal && (
          <ServiceForm
            isOpen={showNewModal}
            serviceGroup={selectedServiceGroup}
            serviceGroupNameList={services}
            service={newService}
            onSave={onSave}
            onClose={onCloseModalClick}
            title={`Add new service `}
            maxRow={displayServices.length + 1}
            errors={errors}
          />
        )}
        {showEditModal && (
          <ServiceForm
            isOpen={showEditModal}
            serviceGroup={selectedServiceGroup}
            serviceGroupNameList={services}
            service={editService}
            onSave={onEditSave}
            onClose={onCloseModalClick}
            title={`Edit the service ${editService?.name}`}
            maxRow={displayServices.length + 1}
            errors={errors}
          />
        )}
        <div className="card p-3 mb-3">
          <div className="row g-3">
            <div className="col-4 form-control-container">
              <div className="   d-flex align-items-center">
                <div className="flex-grow-1">
                  <label
                    htmlFor="tva"
                    className="form-label form-control-label"
                  >
                    Service Group
                  </label>
                  <Combobox
                    onChange={(value) => setSelectedServiceGroup(value)}
                    data={services}
                    dataKey="id"
                    textField="name"
                    value={selectedServiceGroup}
                    defaultValue={selectedServiceGroup}
                    containerClassName={" form-combobox"}
                  />{" "}
                </div>
                <button className="btn btn-primary  ms-3">
                  <img src={plusIcon} alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <Table
          columns={columns}
          data={displayServices}
          onDelete={handleDeleteClick}
          onEdit={onEditClick}
          onAddClick={onAddClick}
          title={"Service List"}
        />
      </div>
    </div>
  );
};

export default Services;
